import $ from "jquery";
import _ from "underscore";
import ExpandCollapseNodeRenderer from "../tree/ExpandCollapseNodeRenderer";
import messageResource from "../../messageResource";

export default function TimeZoneGroupNodeRenderer( tree, selectorFilter, expandCollapseCallback )
{
    ExpandCollapseNodeRenderer.call(this, tree, selectorFilter, expandCollapseCallback);
}

TimeZoneGroupNodeRenderer.prototype = _.create(ExpandCollapseNodeRenderer.prototype);

TimeZoneGroupNodeRenderer.prototype.getEmptyEntityTooltip = function()
{
    return messageResource.getEscapedMessage("users_selector.expand_collapse_disabled.time_zone_group.tooltip");
};

TimeZoneGroupNodeRenderer.prototype.generateLabel = function ( treeNode, labelEl )
{
    var entity = treeNode.getValue();
    var name = entity.name;
    if (entity.id == window.DEFAULT_TIME_ZONE_GROUP_ID)
    {
        labelEl.innerHTML = "<span class='defaultGroupName'>" + this.selectorFilter.highlightTokens(name) + "</span><span class='defaultGroupNote'>&nbsp;" +
                            messageResource.getMessage("users_selector.default_group")+ "</span>";
    }
    else
    {
        labelEl.innerHTML = this.selectorFilter.highlightTokens(name);
    }
    labelEl.title = this.getTitle(treeNode.getValue());
};

TimeZoneGroupNodeRenderer.prototype.appendAdditionalElements = function ( targetEl, treeNode )
{
    var entity = treeNode.getValue();
    if (entity.id == window.DEFAULT_TIME_ZONE_GROUP_ID)
    {
        $(targetEl).addClass("defaultGroup");
    }
};


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/userSelector/TimeZoneGroupNodeRenderer.js